import React, { useEffect, useState, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Grid, Typography, TextField, InputAdornment } from '@mui/material';
import TablePeo from '../../../Components/TablePeo';
import SearchIcon from '@mui/icons-material/Search';
import { useApiGet } from '../../../utils/httpClient';
import { getSPDChaptersList } from '../../../endpoints/chapters';

const headCells = [
  {
    id: 'abbreviation',
    label: 'Abbreviation',
    width: '10%',
    firstCell: true,
  },
  {
    id: 'name',
    label: 'Name',
    width: '50%',
  },
  {
    id: 'chapter_type',
    label: 'Type',
    width: '40%',
  },
];

const SPDChapterList = () => {
  let [searchParams, setSearchParams] = useSearchParams();

  const updateSearchParams = useCallback(
    (key, value) => {
      if (!value || value === '') {
        searchParams.delete(key);
      } else {
        searchParams.set(key, value);
      }
      setSearchParams(searchParams);
    },
    [searchParams, setSearchParams]
  );

  const [order, setOrder] = useState('');
  const [orderBy, setOrderBy] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [search, setSearch] = useState(searchParams.get('search') || '');
  const [delaySearch, setDelaySearch] = useState(
    searchParams.get('search') || ''
  );

  // need up update search params when search changes
  useEffect(() => {
    updateSearchParams('search', search);
  }, [search, updateSearchParams]);

  const { data, isFetching } = useApiGet(
    ['spd-chapters', rowsPerPage, page, orderBy, order, search],
    getSPDChaptersList,
    {
      enabled: true,
      retry: 1,
    },
    {
      rowsPerPage,
      page,
      orderBy,
      order,
      search,
    }
  );

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setSearch(delaySearch);
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [delaySearch]);

  const handleClick = (event, id) => {
    window.location.href = `/spd-chapters/${id}`;
  };

  return (
    <Grid container paddingLeft={2} paddingRight={2}>
      <Grid item xs={12} paddingBottom={5} textAlign={'center'}>
        <Typography variant="h4" color={'primary'}>
          S/P/D Chapter List
        </Typography>
      </Grid>
      <Grid container>
        <Grid item xs={12} sm={6} paddingRight={2} paddingBottom={3}>
          <TextField
            label="Search"
            id="search-field"
            size="small"
            value={delaySearch}
            fullWidth={true}
            onChange={(event) => setDelaySearch(event.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      </Grid>
      <TablePeo
        data={data}
        isFetching={isFetching}
        headCells={headCells}
        handleRowClick={handleClick}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        order={order}
        setOrder={setOrder}
        orderBy={orderBy}
        setOrderBy={setOrderBy}
      />
    </Grid>
  );
};

export default SPDChapterList;
